// components/MetricModules.js - Fixed with better debugging and fallback values
import React from 'react';
import { dashboardStyles } from '../dashboardStyles';

const MetricModules = ({ stats, tableSize }) => {
    // Debug logging
    console.log('📊 MetricModules rendered with props:', { stats, tableSize });

    // Ensure we have valid data with fallbacks
    const safeStats = {
        total: stats?.total || stats?.totalRecords || 0,
        origins: stats?.origins || stats?.uniqueOrigins || 0
    };

    const safeTableSize = {
        size: tableSize?.size || 0,
        unit: tableSize?.unit || 'MB'
    };

    console.log('📊 Using safe values:', { safeStats, safeTableSize });

    const metrics = [
        {
            icon: '📊',
            value: safeStats.total.toLocaleString(),
            label: 'Total Entries',
            color: '#3b82f6',
            borderColor: 'rgba(59, 130, 246, 0.2)',
            rawValue: safeStats.total
        },
        {
            icon: '💾',
            value: `${safeTableSize.size.toFixed(1)}${safeTableSize.unit}`,
            label: 'Table Size',
            color: '#10b981',
            borderColor: 'rgba(16, 185, 129, 0.2)',
            rawValue: safeTableSize.size
        },
        {
            icon: '🌐',
            value: safeStats.origins.toLocaleString(),
            label: 'Unique Origins',
            color: '#8b5cf6',
            borderColor: 'rgba(139, 92, 246, 0.2)',
            rawValue: safeStats.origins
        }
    ];

    return (
        <>
            {metrics.map((metric, index) => (
                <div
                    key={index}
                    style={{
                        ...dashboardStyles.module,
                        ...dashboardStyles.metricModule,
                        border: `1px solid ${metric.borderColor}`,
                        // Add visual indicator if data is missing
                        opacity: metric.rawValue === 0 && metric.label !== 'Table Size' ? 0.6 : 1
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                    title={`${metric.label}: ${metric.value}${metric.rawValue === 0 && metric.label !== 'Table Size' ? ' (Data not loaded)' : ''}`}
                >
                    <div style={{
                        ...dashboardStyles.metricIcon,
                        background: `linear-gradient(135deg, ${metric.color}, transparent)`,
                        border: `1px solid ${metric.color}`
                    }}>
                        {metric.icon}
                    </div>
                    <div style={{
                        ...dashboardStyles.metricValue,
                        color: metric.rawValue === 0 && metric.label !== 'Table Size' ? '#ef4444' : 'inherit'
                    }}>
                        {metric.value}
                        {/* Add loading indicator for zero values */}
                        {metric.rawValue === 0 && metric.label !== 'Table Size' && (
                            <span style={{
                                fontSize: '8px',
                                color: '#ef4444',
                                display: 'block',
                                marginTop: '2px'
                            }}>
                                Loading...
                            </span>
                        )}
                    </div>
                    <div style={dashboardStyles.metricLabel}>
                        {metric.label}
                    </div>
                </div>
            ))}
        </>
    );
};

export default MetricModules;